import React from 'react';
import PropTypes from 'prop-types';

import { Alert, Snackbar } from '@cw-ui/feedback-components';

import {
  formatSubmitSuccessMessage,
  SUBMIT_FAILURE_MESSAGE,
  SUBMIT_FAILURE_TITLE,
  SUBMIT_SUCCESS_TITLE
} from '../../constants';

// @cw-ui toast width is 288px — wider so submit messages don't wrap awkwardly.
const TOAST_ALERT_SX = {
  width: { xs: 'calc(100vw - 32px)', sm: 480 },
  minWidth: { sm: 480 },
  maxWidth: 480
};

const TicketSubmissionToast = ({ outcome, open, onClose }) => {
  const isSuccess = outcome?.type === 'success';

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      role="status"
      aria-live="polite"
      data-testid="ticket-submission-toast"
    >
      <div>
        <Alert
          severity={isSuccess ? 'success' : 'error'}
          width="toast"
          title={isSuccess ? SUBMIT_SUCCESS_TITLE : SUBMIT_FAILURE_TITLE}
          onClose={onClose}
          sx={TOAST_ALERT_SX}
        >
          {isSuccess ? formatSubmitSuccessMessage(outcome.ticketId) : SUBMIT_FAILURE_MESSAGE}
        </Alert>
      </div>
    </Snackbar>
  );
};

TicketSubmissionToast.propTypes = {
  outcome: PropTypes.shape({
    type: PropTypes.oneOf(['success', 'failure']).isRequired,
    ticketId: PropTypes.string
  }),
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default TicketSubmissionToast;
